// import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
// import FacebookIcon from '@mui/icons-material/Facebook';
import FacebookLogin from '@greatsumini/react-facebook-login' //'react-facebook-login/dist/facebook-login-render-props';
import SvgIcons from './SvgIcons';



interface FacebookLoginFormProps {
    logIn: (service: string | null, data?: object | string | null) => void;
    handleClose: () => void;
}

const FacebookLoginForm = (props: FacebookLoginFormProps) => {
    const { FacebookIcon } = SvgIcons();

    const handleFacebookCallback = (response: { status?: string; [key: string]: unknown }) => {
        if (response?.status === "unknown") {
            console.error('Sorry!', 'Something went wrong with facebook Login.');
            return;
        }
        props.logIn('facebook', response);
    }

    return (
        <FacebookLogin
            // buttonStyle={{padding:"6px"}}
            appId={process.env.NEXT_PUBLIC_FACEBOOK_CLIENT_ID??''}
            autoLoad={false}
            fields="name,email,picture"
            onSuccess={handleFacebookCallback}
            render={renderProps => (
                <div onClick={() => { renderProps.onClick?.(); props.handleClose(); }} className="px-5 pt-4 pb-2 grid grid-cols-12 cursor-pointer hover:bg-sky-900">
                    <span className="col-span-2"><FacebookIcon width="22px" height="22px" /></span>
                    <span className="col-span-10">Sign in with Facebook</span>
                </div>
              )}
        />
    );
};

export default FacebookLoginForm;